import angular from "angular";
import template from "./pReports.html";

export function pReportsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pReportsController,
    controllerAs: 'pReports',
    bindToController: true
  };

  return directive;
}

class pReportsController {
  constructor(Auth, Admin, $scope, Notes, $interval, $translate, $q, bModal, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$translate = $translate;
    this.$q = $q;
    this.Notes = Notes;
    this.bModal = bModal;
    this.ConnectionQuality = ConnectionQuality;

    this.fields = {
      name: "info",
      reportType: "info",
      country: "countries",
      sendAt: "info",
      frequency: "info",
      emails: "emails",
      usersNumber: "info",
      language: "language"
    };

    this.globalActions = [
      {
        name: "add",
        functionName: "startAddingNewActiveUsersSubscription",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingActiveUsersSubscription",
        fa: "fa-pencil-alt"
      },
      {
        name: "delete",
        functionName: "startDeletingActiveUsersSubscription",
        fa: "fa-trash"
      },
      {
        name: "send_report",
        functionName: "startSendingReport",
        fa: "fa-envelope"
      }
    ];

    this.reportData = {
      report: {
        type: "select"
      },
      name: {
        type: "text"
      },
      emailAddresses: {
        type: "toDoList"
      },
      reportCountries: {
        type: "multiselect",
      },
      sendAtMonthDay: {
        type: "array"
      },
      everyDay: {
        type: "",
        isNotRequired: true
      },
      language: {
        type: "radioSection",
        options: [
          {
            name: "en",
            label: "EN",
            value: "en"
          },
          {
            name: "de",
            label: "DE",
            value: "de"
          }
        ]
      },
      sendFrequency: {
        type: "radioSection",
        options: [
          {
            name: 'monthly',
            label: this.$translate.instant('REPORTS.MONTHLY'),
            value: 'Monthly'
          },
          {
            name: 'quarterly',
            label: this.$translate.instant('REPORTS.QUARTERLY'),
            value: 'Quarterly'
          },
          {
            name: 'yearly',
            label: this.$translate.instant('REPORTS.YEARLY'),
            value: 'Yearly'
          }
        ]
      },
      reportDetails: {
        type: "",
        isNotRequired: true
      },
      Site: {
        type: "checkbox",
        isNotRequired: true
      }
    };

    this.usersReportExtraDetails = {
      Team: {
        type: "checkbox",
        isNotRequired: true
      },
      Role: {
        type: "checkbox",
        isNotRequired: true
      },
      ProfitCenter: {
        type: "checkbox",
        isNotRequired: true
      },
      ActiveFrom: {
        type: "checkbox",
        isNotRequired: true
      }
    };

    this.reportDataSelect = {
      reportCountries: {
        values: [],
        settings: {
          displayProp: 'name',
          showCheckAll: false,
          showUncheckAll: false,
          smartButtonMaxItems: 2,
          checkBoxes: true,
          scrollableHeight: '250px',
          scrollable: true,
          enableSearch: true,
          closeOnBlur: true,
          searchField: 'name'
        }
      },
      report: {
        valueToAdd: "id",
        valueToShow: "name",
        values: [
          {
            id: "Users",
            name: this.$translate.instant('REPORTS.USERS')
          },
          {
            id: "GroupedUsers",
            name: this.$translate.instant('REPORTS.GROUPED_USERS')
          }
        ]
      },
      sendAtMonthDay: Array.from({length: 31}, (_, i) => i + 1),
    };
    
    this.init();

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          if (!this.user.isLocalAdmin)
            this.Auth.handleUnauthorized();
        }

        let promises = [this.Admin.getActiveUsersSubscriptions(), this.Admin.getCountries()];
        this.$q.all(promises).then(
          ([activeUsersSubscriptions, countries]) => {
            this.activeUsersSubscriptions = activeUsersSubscriptions.data.map(subscription => ({
              ...subscription,
              sendAt: subscription.sendAtMonthDay + " day",
              usersNumber: subscription.emailAddresses.length,
              frequency: subscription.sendFrequency,
              country: subscription.reportCountries.join(", "),
              countryTooltip: subscription.reportCountries.join(", "),
              emails: subscription.emailAddresses.join(", "),
              emailsTooltip: subscription.emailAddresses.join(", "),
              reportType: subscription.report === 'Users' ? this.$translate.instant('REPORTS.USERS') : this.$translate.instant('REPORTS.GROUPED_USERS')
            }));
            this.countries = countries.data;
            this.reportDataSelect.reportCountries.values = this.countries;
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewActiveUsersSubscription() {
    this.modalState = 'new';
    this.modalDialogTitle = 'NEW_REPORT';
    this.modalFunc = this.addNewActiveUsersSubscription;
    this.modalReportData = angular.copy(this.reportData);
    this.activerUsersSubscriptionProcess = true;
    this.activeUsersSubscriptionValues = {
      reportCountries: [],
      language: 'en',
      sendFrequency: 'Monthly',
      emailAddresses: []
    };
  }

  prepareDataToSend(values) {
    const data = angular.copy(values);
    data.reportCountries = data.reportCountries.map(country => country.name);
    data.sendAtMonthDay = Number(data.sendAtMonthDay);
    data.usersReportColumns = [];

    Object.keys(data.report === 'Users' ? this.usersReportExtraDetails : {}).concat(['Site']).forEach(key => {
      if (data[key])
        data.usersReportColumns.push(key);
    });

    return data;
  }

  addNewActiveUsersSubscription(values) {
    this.state = 'loading';

    const data = this.prepareDataToSend(values);

    this.Admin.createActiveUsersSubscription(data).then(
      () => {
        this.init();
        this.activerUsersSubscriptionProcess = false;
        this.modalReportData = null;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  prepareExistingData(subscription) {
    this.modalReportData = angular.copy(this.reportData);
    this.activeUsersSubscriptionValues = angular.copy(subscription);
    if (this.activeUsersSubscriptionValues.report === 'Users')
      this.modalReportData = {...this.modalReportData, ...this.usersReportExtraDetails};
    this.activerUsersSubscriptionProcess = true;
    this.activeUsersSubscriptionValues.sendAtMonthDay = String(subscription.sendAtMonthDay);
    this.activeUsersSubscriptionValues.usersReportColumns.forEach(column => {
      this.activeUsersSubscriptionValues[column] = true;
    });
    this.existingReportDataSelect = angular.copy(this.reportDataSelect);
    this.existingReportDataSelect.report = this.activeUsersSubscriptionValues.report === 'Users'
      ? this.$translate.instant('REPORTS.USERS')
      : this.$translate.instant('REPORTS.GROUPED_USERS');
  }

  startEditingActiveUsersSubscription(subscription) {
    this.modalState = 'edit';
    this.modalDialogTitle = 'EDIT_REPORT';
    this.modalFunc = this.updateActiveUsersSubscription;
    this.prepareExistingData(subscription);
    this.activeUsersSubscriptionValues.reportCountries = this.existingReportDataSelect.reportCountries.values
      .filter(country => subscription.reportCountries.find(reportCountry => reportCountry === country.name));
    this.modalReportData.report.editionDisabled = true;
  }

  updateActiveUsersSubscription(values) {
    this.state = 'loading';
    
    const data = this.prepareDataToSend(values);

    this.Admin.updateActiveUsersSubscription(values.id, data).then(
      () => {
        this.init();
        this.activerUsersSubscriptionProcess = false;
        this.modalReportData = null;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingActiveUsersSubscription(subscription) {
    this.modalState = 'delete';
    this.modalDialogTitle = 'DELETE_REPORT';
    this.modalFunc = this.deleteActiveUsersSubscription;
    this.prepareExistingData(subscription);
    this.activeUsersSubscriptionValues.reportCountries = this.existingReportDataSelect.reportCountries.values
      .filter(country => subscription.reportCountries.find(reportCountry => reportCountry === country.name));
  }

  deleteActiveUsersSubscription(values) {
    this.state = 'loading';

    this.Admin.deleteActiveUsersSubscription(values.id).then(
      () => {
        this.init();
        this.activerUsersSubscriptionProcess = false;
        this.modalReportData = null;
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  formInvalid(values) {
    return (
      !values.report
      || !values.name
      || (!values.emailAddresses || values.emailAddresses.length === 0)
      || (!values.reportCountries || values.reportCountries.length === 0)
      || !values.sendAtMonthDay
      || !values.language
      || !values.sendFrequency
    );
  }

  onTypeChange(key, values) {
    if (key === 'report') {
      if (values.report === 'Users')
        this.modalReportData = {...this.modalReportData, ...this.usersReportExtraDetails};
      else {
        Object.keys(this.usersReportExtraDetails).forEach(key => {
          delete this.modalReportData[key];
        });
      }
    }
  }

  startSendingReport(values) {
    this.sendingReportProcess = true;
    this.reportId = values.id;
  }

  sendReportManually() {
    this.state = 'loading';

    this.Admin.sendActiveUsersSubscriptionManually(this.reportId).then(
      () => {
        this.sendingReportProcess = false;
        this.reportId = null;
        this.state = 'loaded';
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
